module.exports = __webpack_public_path__ + "assets/images/4f9b4665601b2d6f3ec601ca73ded623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/lazard/lazard-0.jpg
// module id = 811
// module chunks = 0